import {
  Invoice,
  OwnerAddEditBilledForPeriod,
  OwnerAddEditInvoice,
  OwnerAR360Report,
  OwnerBilledForPeriodListing,
  OwnerBillingHistory,
  OwnerDashboard,
  OwnerInvoiceListing,
  OwnerPayment360Report,
  OwnerReports,
  OwnerToleranceReport,
} from "@/pages";
import { getOwnerBomBase, routes } from "../utils";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

export const DashboardRoutes = () => {
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const base = getOwnerBomBase(useLocation().pathname);

  return {
    path: routes.dashboard,
    children: [
      {
        path: "",
        element: <OwnerDashboard />,
      },
      {
        path: routes.billedForPeriod,
        element: <OwnerBilledForPeriodListing />,
      },
      {
        path:
          routes.billedForPeriod + "/" + routes.billingId + "/" + routes.action,
        element: <OwnerAddEditBilledForPeriod />,
      },
      {
        path: routes.invoice,
        children: [
          {
            path: "",
            element: communityData?.bom ? (
              <Invoice />
            ) : (
              <Navigate to={`/${base}/${routes.dashboard}`} />
            ),
          },
          {
            // Listing UI based on status
            path: routes.invoiceAction,
            element: communityData?.bom ? (
              <OwnerInvoiceListing />
            ) : (
              <Navigate to={`/${base}/${routes.dashboard}`} />
            ),
          },
          {
            path:
              routes.invoiceAction +
              "/" +
              routes.invoiceId +
              "/" +
              routes.action,
            element: communityData?.bom ? (
              <OwnerAddEditInvoice />
            ) : (
              <Navigate to={`/${base}/${routes.dashboard}`} />
            ),
          },
        ],
      },
      {
        path: routes.reports,
        element: <OwnerReports />,
      },
      {
        path: routes.paymentReport,
        element: <OwnerPayment360Report />,
      },
      {
        path: routes.tolerance,
        element: <OwnerToleranceReport />,
      },
      {
        path: routes.billingHistory,
        element: <OwnerBillingHistory />,
      },
      {
        path: routes.ar360,
        element: <OwnerAR360Report />,
      },
    ],
  };
};
